import React from 'react';
import { FiAlertCircle, FiXCircle, FiInfo, FiAlertTriangle } from 'react-icons/fi';

const ErrorMessage = ({
  message,
  type = 'error',
  onDismiss,
  className = ''
}) => {
  const types = {
    error: { icon: FiXCircle, bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', iconColor: 'text-red-500' },
    warning: { icon: FiAlertTriangle, bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-700', iconColor: 'text-yellow-500' },
    info: { icon: FiInfo, bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', iconColor: 'text-blue-500' },
    success: { icon: FiAlertCircle, bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', iconColor: 'text-green-500' }
  };

  const currentType = types[type] || types.error;
  const Icon = currentType.icon;

  if (!message) return null;

  return (
    <div className={`${currentType.bg} ${currentType.border} border rounded-lg p-4 mb-4 flex items-start justify-between ${className}`}>
      <div className="flex items-start">
        <Icon className={`${currentType.iconColor} mr-3 mt-0.5 flex-shrink-0`} size={20} />
        <p className={`${currentType.text} text-sm`}>{message}</p>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} className={`${currentType.text} hover:opacity-75 transition-opacity`}>
          <FiXCircle size={18} />
        </button>
      )}
    </div>
  );
};

ErrorMessage.Field = ({ error }) => {
  if (!error) return null;
  return (
    <p className="mt-1 text-sm text-red-600 flex items-center">
      <FiAlertCircle className="mr-1" size={14} />
      {error}
    </p>
  );
};

ErrorMessage.API = ({ error, onRetry }) => {
  if (!error) return null;
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
      <FiXCircle className="mx-auto text-red-500 mb-3" size={40} />
      <h3 className="text-lg font-medium text-red-800 mb-2">Something went wrong!</h3>
      <p className="text-red-600 mb-4">{error}</p>
      {onRetry && (
        <button onClick={onRetry} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;